import { render, staticRenderFns } from "./TechnicalDocment.vue?vue&type=template&id=220c6170&scoped=true&"
import script from "./TechnicalDocment.vue?vue&type=script&lang=js&"
export * from "./TechnicalDocment.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalDocment.vue?vue&type=style&index=0&id=220c6170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c6170",
  null
  
)

export default component.exports